import { render, staticRenderFns } from "./ProductionInsurance.vue?vue&type=template&id=7afe4746&"
import script from "./ProductionInsurance.vue?vue&type=script&lang=js&"
export * from "./ProductionInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports